import { View } from 'foundations-components/components/View';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { useIsMobile, useMedia } from 'pricing-pages-ui-components/hooks/useMedia';
import { CommerceFeatures } from '../feature-table/CommerceFeatureTableConfig';
import { CommerceFeatureListItem } from './CommerceFeatureListItem';
import { jsx as _jsx } from "react/jsx-runtime";
export const CommerceFeaturesList = () => {
  const isMobile = useIsMobile();
  const isMaxWidthSdMac = useMedia('sdMac');
  return /*#__PURE__*/_jsx(Grid, {
    marginInline: "0",
    children: CommerceFeatures.map(feature => {
      return /*#__PURE__*/_jsx(GridItem, {
        size: {
          xs: 12,
          md: 6,
          lg: 4
        },
        marginInlineStart: isMobile ? '500' : undefined,
        children: /*#__PURE__*/_jsx(View, {
          paddingInlineStart: isMaxWidthSdMac ? undefined : '1400',
          minBlockSize: isMobile ? '25px' : '50px',
          children: /*#__PURE__*/_jsx(CommerceFeatureListItem, {
            feature: feature
          }, feature.shortName)
        })
      }, feature.shortName);
    })
  });
};